import { mutate, map, Operator } from 'overmind'
import { Rate } from './types'

export const loadRates: () => Operator<void, Rate[]> = () =>
  map(async function loadRates({ effects: { rates } }) {
    return await rates.api.getRates()
  })

export const storeRates: () => Operator<Rate[], void> = () =>
  mutate(function storeRates({ state: { rates: ratesState } }, rates: Rate[]) {
    ratesState.data = rates
  })
